import React, { useRef } from "react";
import { Button } from "react-bootstrap";
import { useHistory } from "react-router";
import "./bounceBackLanding.style.css";
import {Link} from 'react-scroll'

import Forward from '../../images/arrow-forward.svg';

const BounceBackLanding = () => {

  const verifySectionStart = useRef(null)

    const history = useHistory();

    const optOutRoute = () => {
        history.push('/opt-out')
    }

    const verify = () => {
      verifySectionStart.current.scrollIntoView() 
  }


  return (
    <div className="bounce-back-landing-body">
    

      <h1 className="hero-title">
      Verify your Warm Home Discount today.
      </h1>
      <p className="description">
      Complete a few simple steps to verify your Warm Home Discount. If you don’t provide verification, you won’t receive your entitlement.
      </p>
    <div className="signup-btn-div">
    <Button onClick={verify} className="signup-btn-bounce">Verify now</Button>
    </div>
    <p className="sub-text">
    Not sure this applies to you? Opt out today to avoid us contacting you again.
      </p>

      <div className="signup-btn-div">
      <Button onClick={optOutRoute} className="signup-btn learn-btn">
                    Opt out <img src={Forward} />
                </Button>

    </div>
    <div className="scroll-div">
    <p className="scroll-text">Or scroll to learn more</p>
      <Link className="arrow-down-btn" to="facts" smooth={true}>↓</Link>
    </div>
    <div ref={verifySectionStart}></div> 
      </div>
  );
};

export default BounceBackLanding;